module.exports = __webpack_public_path__ + "img/avi.4ba03028.png";